<template>
  <div>
    <div class="card-title">菜单权限</div>
    <el-tree
      ref="tree"
      highlight-current
      :expand-on-click-node="false"
      show-checkbox
      class="tree"
      :data="data"
      :props="defaultProps"
      node-key="id"
      :default-expanded-keys="defaultExpandedKeys"
      :default-checked-keys="defaultCheckedKeys"
      @node-click="handleNodeClick"
    >
      <span class="custom-tree-node" slot-scope="{node, data}">
        <icon-svg class="tree-node-icon" v-if="node.level === 2 && data.icon" :icon-class="data.icon"></icon-svg>
        <span class="custom-tree-node__label">{{node.label}}</span>
      </span>
    </el-tree>
  </div>
</template>

<script>
import {system} from '../../api'

export default {
  name: 'AuthMenuTree',

  props: {
    currentRole: String
  },

  watch: {
    currentRole: {
      immediate: true,
      handler (newValue, oldValue) {
        if (newValue && newValue !== oldValue) this.initMenuTree()
      }
    }
  },

  data () {
    return {
      data: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      defaultExpandedKeys: [],
      defaultCheckedKeys: [],
      // 菜单搜索框内容
      menuName: ''
    }
  },

  methods: {
    setMenuChecked (menuCode, value, setChildrenFlag = true) {
      this.$refs.tree.setChecked(menuCode, value, setChildrenFlag)
    },
    async initMenuTree () {
      let {data} = await system.getRoleMenuTree({loginRoleId: this.$store.state.user.roleId, currentRoleId: this.currentRole, menuName: this.menuName})
      this.data = [data]
      // 默认展开根节点
      this.defaultExpandedKeys = [data.id]
      this.addParentLink(this.data)
      this.washData(this.data)
      this.defaultCheckedKeys = this.getCheckedKeys()
    },
    addParentLink (nodes) {
      let queue = nodes.slice()
      while (queue.length) {
        let p = queue.shift()
        if (p.children && p.children.length !== 0) {
          for (let node of p.children) {
            node.parent = p
            queue.push(node)
          }
        }
      }
    },
    washData (nodes) {
      let unCheckedNodes = this.findAllRightNodes(nodes, x => !x.checked)
      for (let i = unCheckedNodes.length - 1; i >= 0; i--) {
        let node = unCheckedNodes[i]
        let p = node.parent
        while (p) {
          p.checked = false
          p = p.parent
        }
      }
    },
    getCheckedKeys () {
      return this.findAllRightNodes(this.data, x => x.checked).map(x => x.id)
    },
    getCheckedKeysFromTree () {
      return this.$refs.tree.getCheckedNodes(false, true).map(data => data.id)
    },
    handleNodeClick (data, node) {
      this.$emit('update:currentMenuCode', data.id)
    },
    findAllRightNodes (data, judgeFn) {
      let queue = data.slice()
      let result = []
      while (queue.length) {
        let p = queue.shift()
        if (judgeFn(p)) result.push(p)
        if (p.children && p.children.length !== 0) {
          for (let node of p.children) {
            queue.push(node)
          }
        }
      }
      return result
    }
  }
}
</script>

<style scoped>

</style>
